import { render, staticRenderFns } from "./Discontinuation-Activity.vue?vue&type=template&id=0a09d6a0&"
import script from "./Discontinuation-Activity.vue?vue&type=script&lang=js&"
export * from "./Discontinuation-Activity.vue?vue&type=script&lang=js&"
import style0 from "./Discontinuation-Activity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Discontinuation-Activity.vue"
export default component.exports